/* eslint-disable */
import { useState, useEffect } from "react";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
import AddInvoiceForm from "./components/invoiceForm";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import useInvoiceHook from "./useProforma";

const AddInvoice = () => {
  const [menu, setMenu] = useState(false);
  const { id } = useParams();
  const { FetchSingleInvoice } = useInvoiceHook();
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  const { invoice, invoiceLoading } = FetchSingleInvoice(id);
  useEffect(() => {
    let elements = Array.from(
      document.getElementsByClassName("react-datepicker-wrapper")
    );
    elements.map((element) => element.classList.add("w-100"));
  }, []);
  console.log(">>", invoice);

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />
      {!invoiceLoading && invoice && (
        <AddInvoiceForm isEdit={Boolean(id)} id={id} data={invoice} />
      )}
    </div>
  );
};
export default AddInvoice;
